import { useContext, useState } from "react";
import Title from "./Title";
import  {useOnline} from "../utils/useOnline";
import { Link } from "react-router-dom";
// import  {count} from "./RestaurantMenu";
import UserContext from "./UserContext";
import { useSelector } from "react-redux";


/*
const loggedInUser = () => {
     // logic to authenticate user

     return true; // or false;
}
*/
const Header = () => {

     const [isLoggedIn, setIsLoggedIn] = useState(false);

     const {loggedInUser} = useContext(UserContext);

     const cartItems = useSelector((store) => store.cart.items);
     
     return (
          <div className="flex justify-between bg-red-200 shadow-lg sm:bg-gray-300 lg:bg-purple-100 "
          // className='header'
          >
               <Title />
               <div
               className="flex items-center" 
               // className="nav-items"
               >
                    <ul className="p-1 m-1 flex-wrap flex">
                         <Link to="/" className="px-4">
                              <li className="text-2xl">Home</li>
                         </Link>
                         <Link to="/about" className="px-4">
                              <li className="text-2xl">About</li>
                         </Link>
                         <Link to="/contact" className="px-4">
                              <li className="text-2xl">Contact</li>

                         </Link>
                         
                         <Link to="/cart">
                         <li className="px-4 text-2xl">🛒({cartItems.length})</li>
                         </Link>

                         <Link to = "/register" className="px-4">
                              <li className=" text-2xl">Register</li>
                         </Link>
               
               <h1 className="px-3 text-2xl">{(useOnline())? "🟢Online": "🔴Offline"}</h1>
               <h1 className="px-2 text-2xl">{isLoggedIn ? <butt on onClick={() => setIsLoggedIn(false)}>Logout</butt> : <button onClick={() => setIsLoggedIn(true)}>Login</button>}</h1>
               <li className="text-2xl">{loggedInUser}</li>
               </ul>
          </div>
          </div>
     );
}
export default Header; 